module.exports = __webpack_public_path__ + "static/media/desktopScreenshot04.aaf36760.jpg";